import $ from 'jquery';

// Various sanitizing functions for article page.
export default function () {
    // Remove manual inserted ad bb code from article
    $('.ad-bbcode').parent().parent('.sidebar').remove();
}
